function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("sodipodinamedview", {
  bordercolor: "#666666",
  borderopacity: 1,
  gridtolerance: 10,
  guidetolerance: 10,
  id: "namedview3747",
  inkscapecurrentLayer: "svg3741",
  inkscapeCx: 896,
  inkscapeCy: 896,
  inkscapePageopacity: 0,
  inkscapePageshadow: 2,
  inkscapeWindowHeight: 480,
  inkscapeWindowMaximized: 0,
  inkscapeWindowWidth: 640,
  inkscapeWindowX: 0,
  inkscapeWindowY: 25,
  inkscapeZoom: 0.13169643,
  objecttolerance: 10,
  pagecolor: "#ffffff",
  showgrid: "false"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "g3743",
  transform: "matrix(1,0,0,-1,197.42373,1255.0508)"
}, React.createElement("path", {
  id: "path3745",
  d: "M-157,1207.6v-45c0-0.7-0.2-1.3-0.7-1.8s-1.1-0.7-1.8-0.7h-5 c-0.7,0-1.3,0.2-1.8,0.7s-0.7,1.1-0.7,1.8v45c0,0.7,0.2,1.3,0.7,1.8s1.1,0.7,1.8,0.7h5c0.7,0,1.3-0.2,1.8-0.7 S-157,1208.3-157,1207.6z M-137,1207.6v-45c0-0.7-0.2-1.3-0.7-1.8s-1.1-0.7-1.8-0.7h-5c-0.7,0-1.3,0.2-1.8,0.7s-0.7,1.1-0.7,1.8v45 c0,0.7,0.2,1.3,0.7,1.8s1.1,0.7,1.8,0.7h5c0.7,0,1.3-0.2,1.8-0.7S-137,1208.3-137,1207.6z M-117,1207.6v-45c0-0.7-0.2-1.3-0.7-1.8 s-1.1-0.7-1.8-0.7h-5c-0.7,0-1.3,0.2-1.8,0.7s-0.7,1.1-0.7,1.8v45c0,0.7,0.2,1.3,0.7,1.8s1.1,0.7,1.8,0.7h5c0.7,0,1.3-0.2,1.8-0.7 S-117,1208.3-117,1207.6z M-107,1151v74.1h-70V1151c0-1.1,0.2-2.2,0.5-3.2c0.4-1,0.7-1.7,1.1-2.1s0.7-0.7,0.8-0.7h65 c0.2,0,0.4,0.2,0.8,0.7s0.8,1.1,1.1,2.1S-107,1149.8-107,1151z M-159.5,1235.1h35l-3.7,9.1c-0.4,0.5-0.8,0.8-1.3,0.9h-24.8 c-0.5-0.1-1-0.4-1.3-0.9L-159.5,1235.1z M-87,1232.6v-5c0-0.7-0.2-1.3-0.7-1.8s-1.1-0.7-1.8-0.7H-97V1151c0-4.3-1.2-8.1-3.7-11.2 s-5.4-4.7-8.8-4.7h-65c-3.4,0-6.4,1.5-8.8,4.6c-2.4,3-3.7,6.7-3.7,11.1v74.4h-7.5c-0.7,0-1.3,0.2-1.8,0.7s-0.7,1.1-0.7,1.8v5 c0,0.7,0.2,1.3,0.7,1.8s1.1,0.7,1.8,0.7h24.1l5.5,13c0.8,1.9,2.2,3.6,4.2,4.9s4.1,2,6.2,2h25c2.1,0,4.1-0.7,6.2-2s3.4-3,4.2-4.9 l5.5-13h24.1c0.7,0,1.3-0.2,1.8-0.7S-87,1233.3-87,1232.6z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "svg3741",
    sodipodidocname: "trash_font_awesome.svg",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.4 120",
    style: {
      "enableBackground": "new 0 0 110.4 120"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/trash.9e35a620.svg";
export { SvgComponent as ReactComponent };